import { createSlice } from '@reduxjs/toolkit'
import moment from 'moment';

const initialState = {
    version: '8.0.0',
    activeWorkouts: []
}

const initialWorkoutState = {
    version: '4.0',
    profileType: null,
    id: null,
    groupId: null,
    groupName: null,
    groupAthletes: [],
    athleteId: null,
    athleteName: null,
    weekOfTheYearKey: null,
    programPhaseKey: null,
    programPhaseWeekIndex: null,
    sportTypeKey: "",
    workoutType: null,
    workoutTemplateKey: null,
    uiMode: 'compact',
    taperData: null,
    workoutTemplate: null,
    phaseIndex: 0,
    exerciseIndex: 0,
    setIndex: 0,
    activeCardIndex: 0,
    tourTaken: false
}

const activeWorkoutSlice = createSlice({
    name: 'activeWorkout',
    initialState,
    reducers: {
        initializeGroupActiveWorkout: (state, action) => {

            const { 
                profileType, 
                id,
                groupId,
                groupName,
                groupAthletes,
                weekOfTheYearKey,
                programPhaseKey,
                programPhaseWeekIndex,
                workoutType,
                workoutTemplateKey,
                taperData,
                workoutTemplate
            } = action.payload

            var newWorkout = JSON.parse(JSON.stringify(initialWorkoutState))

            newWorkout.profileType = profileType
            newWorkout.id = id
            newWorkout.groupId = groupId
            newWorkout.groupName = groupName
            newWorkout.groupAthletes = groupAthletes
            newWorkout.weekOfTheYearKey = weekOfTheYearKey
            newWorkout.programPhaseKey = programPhaseKey
            newWorkout.programPhaseWeekIndex = programPhaseWeekIndex
            newWorkout.workoutType = workoutType
            newWorkout.workoutTemplateKey = workoutTemplateKey
            newWorkout.workoutTemplate = workoutTemplate
            newWorkout.taperData = taperData

            newWorkout.phaseIndex = 0
            newWorkout.exerciseIndex = 0
            newWorkout.setIndex = 0
            newWorkout.activeCardIndex = 0

            state.activeWorkouts.push(newWorkout)

        },
        initializeIndividualActiveWorkout: (state, action) => {

            const { 
                profileType, 
                id,
                athleteId,
                athleteName,
                weekOfTheYearKey,
                programPhaseKey,
                programPhaseWeekIndex,
                workoutType,
                workoutTemplateKey,
                taperData,
                workoutTemplate
            } = action.payload

            var newWorkout = JSON.parse(JSON.stringify(initialWorkoutState))

            newWorkout.profileType = profileType
            newWorkout.id = id
            newWorkout.athleteId = athleteId
            newWorkout.athleteName = athleteName
            newWorkout.weekOfTheYearKey = weekOfTheYearKey
            newWorkout.programPhaseKey = programPhaseKey
            newWorkout.programPhaseWeekIndex = programPhaseWeekIndex
            newWorkout.workoutType = workoutType
            newWorkout.workoutTemplateKey = workoutTemplateKey
            newWorkout.taperData = taperData
            newWorkout.workoutTemplate = workoutTemplate
            newWorkout.phaseIndex = 0
            newWorkout.exerciseIndex = 0
            newWorkout.setIndex = 0
            newWorkout.activeCardIndex = 0

            state.activeWorkouts.push(newWorkout)

        },
        initializeActiveWorkoutV5: (state, action) => {

            const { 
                version,
                profileType, 
                id,
                athleteId,
                athleteName,
                weekOfTheYearKey,
                workoutType,
                taperData,
                workoutTemplate
            } = action.payload

            var newWorkout = JSON.parse(JSON.stringify(initialWorkoutState))

            newWorkout.version = version
            newWorkout.profileType = profileType
            newWorkout.id = id
            newWorkout.athleteId = athleteId
            newWorkout.athleteName = athleteName
            newWorkout.weekOfTheYearKey = weekOfTheYearKey
            newWorkout.workoutType = workoutType
            newWorkout.taperData = taperData
            newWorkout.workoutTemplate = workoutTemplate
            newWorkout.phaseIndex = 0
            newWorkout.exerciseIndex = 0
            newWorkout.setIndex = 0
            newWorkout.activeCardIndex = 0

            state.activeWorkouts.push(newWorkout)

        },
        setPhaseExpanded: (state, action) => {

            const { profileType, groupId, athleteId, phaseIndex, value } = action.payload

            const workout = GetActiveWorkout(state, profileType, groupId, athleteId)

            workout.workoutTemplate.phases[phaseIndex].expanded = value

        },
        setSetUnitsCompleted: (state, action) => {

            const { profileType, groupId, athleteId, phaseIndex, exerciseIndex, setIndex, setUnitsCompleted } = action.payload

            const workout = GetActiveWorkout(state, profileType, groupId, athleteId)

            const currentSet = workout.workoutTemplate.phases[phaseIndex].exercises[exerciseIndex].sets[setIndex];

            switch (profileType) {

                case 'group':

                    // Update shared group value

                    currentSet.completedSetData.setUnitsCompleted = setUnitsCompleted;

                    // Update all athletes in the group that have not overridden the input

                    for (const athlete of workout.groupAthletes) {
                        if (currentSet.groupIndividualAthleteDetails[athlete.id].groupIndividualOverrideInputs === false) {
                            currentSet.groupIndividualCompletedSetData[athlete.id].setUnitsCompleted = setUnitsCompleted;
                        }
                    }

                    break;

                case 'group-individual':
                    currentSet.groupIndividualAthleteDetails[athleteId].groupIndividualOverrideInputs = true;
                    currentSet.groupIndividualCompletedSetData[athleteId].setUnitsCompleted = setUnitsCompleted;
                    break;

                case 'individual':
                    currentSet.completedSetData.setUnitsCompleted = setUnitsCompleted;
                    break;

                default:
                    console.error(`Invalid profile type: ${profileType}`)
                    break;

            }

        },
        setMovementDifficulty: (state, action) => {

            const { profileType, groupId, athleteId, phaseIndex, exerciseIndex, setIndex, value } = action.payload

            const workout = GetActiveWorkout(state, profileType, groupId, athleteId)

            const currentSet = workout.workoutTemplate.phases[phaseIndex].exercises[exerciseIndex].sets[setIndex];

            switch (profileType) {

                case 'group':

                    // Update shared group value

                    currentSet.completedSetData.movementDifficulty = value;

                    // Update all athletes in the group that have not overridden the input

                    for (const athlete of workout.groupAthletes) {
                        if (currentSet.groupIndividualAthleteDetails[athlete.id].groupIndividualOverrideInputs === false) {
                            currentSet.groupIndividualCompletedSetData[athlete.id].movementDifficulty = value;
                        }
                    }

                    break;

                case 'group-individual':
                    currentSet.groupIndividualAthleteDetails[athleteId].groupIndividualOverrideInputs = true;
                    currentSet.groupIndividualCompletedSetData[athleteId].movementDifficulty = value;
                    break;

                case 'individual':
                    currentSet.completedSetData.movementDifficulty = value;
                    break;

                default:
                    console.error(`Invalid profile type: ${profileType}`)
                    break;

            }

        },
        setLoadDifficulty: (state, action) => {

            const { profileType, groupId, athleteId, phaseIndex, exerciseIndex, setIndex, value } = action.payload

            const workout = GetActiveWorkout(state, profileType, groupId, athleteId)

            const currentSet = workout.workoutTemplate.phases[phaseIndex].exercises[exerciseIndex].sets[setIndex];

            switch (profileType) {

                case 'group':

                    // Update shared group value

                    currentSet.completedSetData.difficulty = value;

                    // Update all athletes in the group that have not overridden the input

                    for (const athlete of workout.groupAthletes) {
                        if (currentSet.groupIndividualAthleteDetails[athlete.id].groupIndividualOverrideInputs === false) {
                            currentSet.groupIndividualCompletedSetData[athlete.id].difficulty = value;
                        }
                    }

                    break;

                case 'group-individual':
                    currentSet.groupIndividualAthleteDetails[athleteId].groupIndividualOverrideInputs = true;
                    currentSet.groupIndividualCompletedSetData[athleteId].difficulty = value;
                    break;

                case 'individual':
                    currentSet.completedSetData.difficulty = value;
                    break;

                default:
                    console.error(`Invalid profile type: ${profileType}`)
                    break;

            }

        },
        setCompleted: (state, action) => {

            const { profileType, groupId, athleteId, phaseIndex, exerciseIndex, setIndex, value } = action.payload

            const workout = GetActiveWorkout(state, profileType, groupId, athleteId)

            const currentSet = workout.workoutTemplate.phases[phaseIndex].exercises[exerciseIndex].sets[setIndex];

            switch (profileType) {

                case 'group':

                    // Update shared group value

                    currentSet.completedSetData.completed = value;
                    if (value === true) currentSet.completedSetData.completedTimestamp = moment().utc().format('YYYY-MM-DD HH:mm:ss');
                    if (value === false) currentSet.completedSetData.completedTimestamp = null;

                    // Update all athletes in the group that have not overridden the input

                    for (const athlete of workout.groupAthletes) {
                        if (currentSet.groupIndividualAthleteDetails[athlete.id].groupIndividualOverrideInputs === false) {
                            currentSet.groupIndividualCompletedSetData[athlete.id].completed = value;
                            if (value === true) currentSet.groupIndividualCompletedSetData[athlete.id].completedTimestamp = moment().utc().format('YYYY-MM-DD HH:mm:ss');
                            if (value === false) currentSet.groupIndividualCompletedSetData[athlete.id].completedTimestamp = null;
                        }
                    }

                    break;

                case 'group-individual':
                    currentSet.groupIndividualAthleteDetails[athleteId].groupIndividualOverrideInputs = true;
                    currentSet.groupIndividualCompletedSetData[athleteId].completed = value;
                    if (value === true) currentSet.groupIndividualCompletedSetData[athleteId].completedTimestamp = moment().utc().format('YYYY-MM-DD HH:mm:ss');
                    if (value === false) currentSet.groupIndividualCompletedSetData[athleteId].completedTimestamp = null;
                    break;

                case 'individual':
                    currentSet.completedSetData.completed = value;
                    if (value === true) currentSet.completedSetData.completedTimestamp = moment().utc().format('YYYY-MM-DD HH:mm:ss');
                    if (value === false) currentSet.completedSetData.completedTimestamp = null;
                    break;

                default:
                    console.error(`Invalid profile type: ${profileType}`)
                    break;

            }

        },
        setSkipped: (state, action) => {

            const { profileType, groupId, athleteId, phaseIndex, exerciseIndex, setIndex, value } = action.payload

            const workout = GetActiveWorkout(state, profileType, groupId, athleteId)

            const currentSet = workout.workoutTemplate.phases[phaseIndex].exercises[exerciseIndex].sets[setIndex]

            switch (profileType) {

                case 'group':

                    // Update shared group value

                    currentSet.completedSetData.skipped = value;

                    // Update all athletes in the group that have not overridden the input

                    for (const athlete of workout.groupAthletes) {
                        if (currentSet.groupIndividualAthleteDetails[athlete.id].groupIndividualOverrideInputs === false) {
                            currentSet.groupIndividualCompletedSetData[athlete.id].skipped = value;
                        }
                    }

                    break;

                case 'group-individual':
                    currentSet.groupIndividualAthleteDetails[athleteId].groupIndividualOverrideInputs = true;
                    currentSet.groupIndividualCompletedSetData[athleteId].skipped = value;
                    break;

                case 'individual':
                    currentSet.completedSetData.skipped = value;
                    break;

                default:
                    console.error(`Invalid profile type: ${profileType}`)
                    break;

            }

        },
        updateActiveWorkoutSetRepsAssigned: (state, action) => {

            const { profileType, groupId, athleteId, phaseIndex, exerciseIndex, setIndex, bumpAmount } = action.payload

            const workout = GetActiveWorkout(state, profileType, groupId, athleteId)

            const currentSet = workout.workoutTemplate.phases[phaseIndex].exercises[exerciseIndex].sets[setIndex];

            // If we are bumping up

            if (bumpAmount > 0) {

                // Only bump up to 15 reps if we are already below 15. Otherwise keep it where it is

                if (currentSet.reps < 15) {
                    var newReps = Math.min(15, currentSet.reps + bumpAmount)
                    currentSet.reps = newReps
                    currentSet.completedSetData.setUnitsCompleted = newReps
                }

            }

            // If we are bumping down

            if (bumpAmount <= 0) {
                var newReps = Math.max(5, currentSet.reps + bumpAmount)
                currentSet.reps = newReps
                currentSet.completedSetData.setUnitsCompleted = newReps
            }

        },
        setActiveWorkoutIncompleteSetInfo: (state, action) => {

            const {
                profileType, 
                groupId, 
                athleteId, 
                phaseIndex, 
                exerciseIndex, 
                setIndex,
                weightRecommendation,
                weightRecommendationRounded,
                formulaTag,
                equipmentDetails
            } = action.payload

            const workout = GetActiveWorkout(state, profileType, groupId, athleteId)

            if (workout === null) {
                return
            }

            const currentSet = workout.workoutTemplate.phases[phaseIndex].exercises[exerciseIndex].sets[setIndex];

            switch (profileType) {

                case 'group':

                    // Update shared group value

                    currentSet.recommendationData.weightRecommendationLoaded = true;
                    currentSet.recommendationData.weightRecommendation = weightRecommendation;
                    currentSet.recommendationData.weightRecommendationRounded = weightRecommendationRounded;
                    currentSet.recommendationData.labelWeightRecommendationRounded = weightRecommendationRounded;
                    currentSet.recommendationData.formulaTag = formulaTag;
                    currentSet.recommendationData.equipmentDetails = equipmentDetails;

                    // Update all athletes in the group that have not overridden the input

                    for (const athlete of workout.groupAthletes) {
                        if (currentSet.groupIndividualAthleteDetails[athlete.id].groupIndividualOverrideInputs === false) {
                            currentSet.groupIndividualRecommendationData[athlete.id].weightRecommendationLoaded = true;
                            currentSet.groupIndividualRecommendationData[athlete.id].weightRecommendation = weightRecommendation;
                            currentSet.groupIndividualRecommendationData[athlete.id].weightRecommendationRounded = weightRecommendationRounded;
                            currentSet.groupIndividualRecommendationData[athlete.id].labelWeightRecommendationRounded = weightRecommendationRounded;
                            currentSet.groupIndividualRecommendationData[athlete.id].formulaTag = formulaTag;
                            currentSet.groupIndividualRecommendationData[athlete.id].equipmentDetails = equipmentDetails;
                        }
                    }

                    break;
                
                case 'individual':
                    currentSet.recommendationData.weightRecommendationLoaded = true;
                    currentSet.recommendationData.weightRecommendation = weightRecommendation;
                    currentSet.recommendationData.weightRecommendationRounded = weightRecommendationRounded;
                    currentSet.recommendationData.labelWeightRecommendationRounded = weightRecommendationRounded;
                    currentSet.recommendationData.formulaTag = formulaTag;
                    currentSet.recommendationData.equipmentDetails = equipmentDetails;
                    break;

                default:
                    console.error(`Invalid profile type: ${profileType} for setActiveWorkoutIncompleteSetInfo`)
                    break;

            }

        },
        resetActiveWorkoutIncompleteSetInfo: (state, action) => {

            const { profileType, groupId, athleteId, phaseIndex, exerciseIndex, setIndex } = action.payload

            const workout = GetActiveWorkout(state, profileType, groupId, athleteId)

            const currentSet = workout.workoutTemplate.phases[phaseIndex].exercises[exerciseIndex].sets[setIndex];

            currentSet.recommendationData.weightRecommendationLoaded = false;
            currentSet.recommendationData.weightRecommendation = 0;
            currentSet.recommendationData.weightRecommendationRounded = 0;
            currentSet.recommendationData.labelWeightRecommendationRounded = 0;
            currentSet.recommendationData.formulaTag = "";
            currentSet.recommendationData.equipmentDetails = null;

        },
        setActiveWorkoutExerciseSetWeightOverride: (state, action) => {

            const { 
                profileType, 
                groupId, 
                athleteId, 
                phaseIndex, 
                exerciseIndex, 
                setIndex, 
                weightRecommendation, 
                weightRecommendationRounded, 
                override 
            } = action.payload

            const workout = GetActiveWorkout(state, profileType, groupId, athleteId)

            const currentSet = workout.workoutTemplate.phases[phaseIndex].exercises[exerciseIndex].sets[setIndex];

            switch (profileType) {

                case 'group':

                    currentSet.recommendationData.weightRecommendation = weightRecommendation;
                    currentSet.recommendationData.weightRecommendationRounded = weightRecommendationRounded;
                    currentSet.completedSetData.override = override;

                    for (const athlete of workout.groupAthletes) {
                        if (currentSet.groupIndividualAthleteDetails[athlete.id].groupIndividualOverrideInputs === false) {
                            currentSet.groupIndividualRecommendationData[athlete.id].weightRecommendation = weightRecommendation;
                            currentSet.groupIndividualRecommendationData[athlete.id].weightRecommendationRounded = weightRecommendationRounded;
                            currentSet.groupIndividualRecommendationData[athlete.id].override = override;
                        }
                    }

                    break;

                case 'group-individual':
                    currentSet.groupIndividualAthleteDetails[athleteId].groupIndividualOverrideInputs = true;
                    currentSet.groupIndividualRecommendationData[athleteId].weightRecommendation = weightRecommendation;
                    currentSet.groupIndividualRecommendationData[athleteId].weightRecommendationRounded = weightRecommendationRounded;
                    currentSet.groupIndividualRecommendationData[athleteId].override = override;
                    break;

                case 'individual':
                    currentSet.recommendationData.weightRecommendation = weightRecommendation;
                    currentSet.recommendationData.weightRecommendationRounded = weightRecommendationRounded;
                    currentSet.completedSetData.override = override;
                    break;

                default:
                    console.error(`Invalid profile type: ${profileType} for setActiveWorkoutIncompleteSetInfo`)
                    break;

            }

        },
        swapActiveWorkoutExercise: (state, action) => {

            const { profileType, groupId, athleteId, phaseIndex, exerciseIndex, swapType, swapExercise } = action.payload

            const workout = GetActiveWorkout(state, profileType, groupId, athleteId)

            const currentExercise = workout.workoutTemplate.phases[phaseIndex].exercises[exerciseIndex];

            // Store current exercise for undo logic

            const storageExercise = {
                id: currentExercise.id,
                name: currentExercise.name,
                exerciseType: currentExercise.exerciseType,
                lateral: currentExercise.lateral,
                setUnit: currentExercise.setUnit,
                videoUrl: currentExercise.videoUrl,
                generationVariables: currentExercise.generationVariables,
                equipment: currentExercise.equipment
            }

            currentExercise.originalExerciseStorage = storageExercise

            // Update exercise

            currentExercise.id = swapExercise.id;
            currentExercise.name = swapExercise.name;
            currentExercise.exerciseType = swapExercise.exerciseType;
            currentExercise.lateral = swapExercise.lateral;
            currentExercise.setUnit = swapExercise.setUnit;
            currentExercise.videoUrl = swapExercise.videoUrl;
            currentExercise.generationVariables = { fetchType: swapType }
            currentExercise.equipment = swapExercise.equipment

        },
        undoExerciseSwap: (state, action) => {

            const { profileType, groupId, athleteId, phaseIndex, exerciseIndex } = action.payload

            const workout = GetActiveWorkout(state, profileType, groupId, athleteId)

            const currentExercise = workout.workoutTemplate.phases[phaseIndex].exercises[exerciseIndex];

            // Update exercise

            currentExercise.id = currentExercise.originalExerciseStorage.id;
            currentExercise.name = currentExercise.originalExerciseStorage.name;
            currentExercise.exerciseType = currentExercise.originalExerciseStorage.exerciseType;
            currentExercise.lateral = currentExercise.originalExerciseStorage.lateral;
            currentExercise.setUnit = currentExercise.originalExerciseStorage.setUnit;
            currentExercise.videoUrl = currentExercise.originalExerciseStorage.videoUrl;
            currentExercise.generationVariables = currentExercise.originalExerciseStorage.generationVariables
            currentExercise.equipment = currentExercise.originalExerciseStorage.equipment

            // Clear stored exercise

            currentExercise.originalExerciseStorage = null

        },
        resetGroupIndividualOverrideInputs: (state, action) => {

            const { profileType, groupId, athleteId, phaseIndex, exerciseIndex, setIndex } = action.payload

            const workout = GetActiveWorkout(state, profileType, groupId, athleteId)

            const currentSet = workout.workoutTemplate.phases[phaseIndex].exercises[exerciseIndex].sets[setIndex];

            currentSet.groupIndividualRecommendationData[athleteId] = JSON.parse(JSON.stringify(currentSet.recommendationData));
            currentSet.groupIndividualCompletedSetData[athleteId] = JSON.parse(JSON.stringify(currentSet.completedSetData));
            currentSet.groupIndividualAthleteDetails[athleteId].groupIndividualOverrideInputs = false;

        },
        removeWorkoutFromActiveWorkouts: (state, action) => {

            const { profileType, groupId, athleteId } = action.payload

            const activeWorkoutIndex = state.activeWorkouts.findIndex(workout => (
                (profileType === 'group' && workout.profileType === profileType && parseInt(workout.groupId) === parseInt(groupId))
                || (profileType === 'individual' && workout.profileType === profileType && parseInt(workout.athleteId) === parseInt(athleteId))
            ))
        
            if (activeWorkoutIndex !== -1) {
                state.activeWorkouts.splice(activeWorkoutIndex, 1)
            }

        },
        removeWorkoutV5FromActiveWorkouts: (state, action) => {
            const { workoutId } = action.payload

            const activeWorkoutIndex = state.activeWorkouts.findIndex(workout => (
                workout.version === '5.0' 
                && workout.id === workoutId
            ))
        
            if (activeWorkoutIndex !== -1) {
                state.activeWorkouts.splice(activeWorkoutIndex, 1)
            }
        },
        TEST_setOutdatedActiveWorkoutState: (state) => {
            state.version = '6.0.0'
        },
        resetActiveWorkoutState: () => initialState,
    },
});

export const {
    initializeGroupActiveWorkout,
    initializeIndividualActiveWorkout,
    initializeActiveWorkoutV5,
    setPhaseExpanded,
    setSetUnitsCompleted,
    setMovementDifficulty,
    setLoadDifficulty,
    setCompleted,
    setSkipped,
    updateActiveWorkoutSetRepsAssigned,
    setActiveWorkoutIncompleteSetInfo,
    resetActiveWorkoutIncompleteSetInfo,
    setActiveWorkoutExerciseSetWeightOverride,
    swapActiveWorkoutExercise,
    undoExerciseSwap,
    resetGroupIndividualOverrideInputs,
    removeWorkoutFromActiveWorkouts,
    removeWorkoutV5FromActiveWorkouts,
    resetActiveWorkoutState
} = activeWorkoutSlice.actions;

export const GetActiveWorkout = (activeWorkoutState = null, profileType = 'individual', groupId = 0, athleteId = 0) => {

    const activeWorkout = activeWorkoutState.activeWorkouts.find(workout => (
        (profileType === 'group' && workout.profileType === profileType && parseInt(workout.groupId) === parseInt(groupId))
        || (profileType === 'group-individual' && workout.profileType === 'group' && parseInt(workout.groupId) === parseInt(groupId)) // Still search for group workout when profileType is group-individual
        || (profileType === 'individual' && workout.profileType === profileType && parseInt(workout.athleteId) === parseInt(athleteId))
    ))

    if (!activeWorkout) {
        return null
    }

    // console.log(activeWorkout)

    return activeWorkout

}

export const GetActiveWorkoutV5 = (activeWorkoutState = null, profileType = 'individual', workoutId) => {

    const activeWorkoutV5 = activeWorkoutState.activeWorkouts.find(workout => (
        workout.version === '5.0'
        && workout.profileType === profileType
        && workout.id === workoutId 
    ))

    if (!activeWorkoutV5) {
        return null
    }

    // console.log(activeWorkoutV5)

    return activeWorkoutV5

}

export default activeWorkoutSlice.reducer;
